import type { IRiskInsuranceRequirementsNatureOfServiceSought } from './RiskInsuranceRequirementsNatureOfServiceSought.interface';

export default class RiskInsuranceRequirementsNatureOfServiceSought
  implements IRiskInsuranceRequirementsNatureOfServiceSought {
  untimelyDeath: boolean;
  sufferingASeriousCriticalIllness: boolean;
  sufferingAPermanentOrTemporaryDisablement: boolean;
  lossOfIncomeThroughSicknessOrDisability: boolean;
  requiringTimelyHospitalOrSpecialistOrDiagnosticTests: boolean;
  combinedPersonalRiskAnalysis: boolean;

  static build = (data: IRiskInsuranceRequirementsNatureOfServiceSought) =>
    new RiskInsuranceRequirementsNatureOfServiceSought(data);

  static blank = () => new RiskInsuranceRequirementsNatureOfServiceSought();

  /**
   * Constructor
   * @param {IRiskInsuranceRequirementsNatureOfServiceSought} data
   */
  constructor(data?: IRiskInsuranceRequirementsNatureOfServiceSought) {
    this.untimelyDeath = data?.untimelyDeath === true;
    this.sufferingASeriousCriticalIllness = data?.sufferingASeriousCriticalIllness === true;
    this.sufferingAPermanentOrTemporaryDisablement =
      data?.sufferingAPermanentOrTemporaryDisablement === true;
    this.lossOfIncomeThroughSicknessOrDisability =
      data?.lossOfIncomeThroughSicknessOrDisability === true;
    this.requiringTimelyHospitalOrSpecialistOrDiagnosticTests =
      data?.requiringTimelyHospitalOrSpecialistOrDiagnosticTests === true;
    this.combinedPersonalRiskAnalysis = data?.combinedPersonalRiskAnalysis === true;
  }
}
